/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
// import 'antd/dist/antd.css';
import { Row, Col, Card, Form, Input, Checkbox, Button, Select } from 'antd';
// import '../../css/ant-design-style.css';
import './style.css';
// import { REQUEST_REGISTER } from './constants';
// import { makeSelectRequesting, selectCountryList } from './selector';
import phoneCodes from '../../JSON/phonecodes.json';
import { Content } from 'antd/es/layout/layout';
import { useDispatch, useSelector } from 'react-redux';
import { createUserRequest } from './Actions';
import { selectLoading, selectSuccessMsg } from './Selectors';
import CustomSpin from '../CommonSpin';
import { useNavigate } from 'react-router-dom';
import { BodyTextHeading, ButtonText } from '../CommonText';

import english from '../../Translations/English.json';
import hindi from '../../Translations/Hindi.json';
import malayalam from '../../Translations/Malayalam.json';

const { Option } = Select;

const Register = () => {
    const [confirmDirty, setConfirmDirty] = useState(false);
    // const [autoCompleteResult, setAutoCompleteResult] = useState([]);
    // const [countryCallingCodes, setCountryCallingCodes] = useState('+91');
    const [phoneNumberLength, setPhoneNumberLength] = useState([10]);
    const [phoneNumber, setPhoneNumber] = useState(null);
    const [passwordVisible, setPasswordVisible] = useState(false);
    const [countryCode, setCountryCode ] = useState('+91');

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const requesting = useSelector(selectLoading);

    const successMsg = useSelector(selectSuccessMsg);

    const langid = localStorage.getItem('INTL') ? (localStorage.getItem('INTL')) : 'en';
    const langdata = langid && langid == 'en' ? english : langid == 'ma' ? malayalam : langid == 'hin' ? hindi : english;
    
    
    if(successMsg) {
        navigate('/addprofile');
    }

    const [form] = Form.useForm();  // useForm hook for managing the form state

    useEffect(() => {
        // dispatch({ type: 'REQUEST_COUNTRY_CODE' });
    }, [dispatch]);

    const handleSubmit = (value) => {
        const payload = {
            email: value.email,
            cellphone: value.phone,
            password: value.confirm,
            countryCode: countryCode,
        };
        dispatch(createUserRequest(payload));
    };

    const handleConfirmBlur = (e) => {
        const value = e.target.value;        
        setConfirmDirty(confirmDirty || !value);
    };    

    const compareToFirstPassword = (rule, value) => {
        if (value && value !== form.getFieldValue('password')) {
            return Promise.reject(new Error(langdata.Passwordmismatch ? langdata.Passwordmismatch : 'Password mismatch....!'));
        } else if (value && value.length < 8) {
            return Promise.reject(new Error(langdata.Passwordmusthaveatleast8characters ? langdata.Passwordmusthaveatleast8characters : 'Password must have at least 8 characters!'));
        } else {
            return Promise.resolve();     
        }
    };

    const validateToNextPassword = (rule, value) => {
        if (value && confirmDirty) {            
            form.validateFields(['confirm'], { force: true });
        }
        return Promise.resolve();     
    };

    const validatePhone = (rule, value) => {
        // If input is empty, skip validation
        if (!value || value.length === 0) {
            return Promise.resolve();
        }

        // Get allowed lengths (number or array)
        const allowed = phoneNumberLength; // e.g., 10 or [10, 11]
        const allowedLengths = Array.isArray(allowed) ? allowed : [allowed];

        // Check that value contains only digits
        if (!/^[0-9]+$/.test(value)) {
            return Promise.reject(
                new Error(
                    langdata.Phonenumbernotvalid
                        ? langdata.Phonenumbernotvalid
                        : 'Phone number must contain only digits!'
                )
            );
        }

        // Check if input length matches any allowed length
        const isValidLength = allowedLengths.includes(value.length);

        if (!isValidLength) {
            return Promise.reject(
                new Error(
                    langdata.Phonenumbernotvalid
                        ? langdata.Phonenumbernotvalid
                        : 'Phone number not valid!'
                )
            );
        }

        // ✅ Passed all checks
        return Promise.resolve();
    };


    const checkCheckBox = (_, value) => {
        if (!value) {
            return Promise.reject(new Error(langdata.Pleaseagreethetermsandconditions ? langdata.Pleaseagreethetermsandconditions : 'Please agree the terms and conditions!'));
        }
        return Promise.resolve();
    };

    const changeCountryCode = (value) => {
        const selectedCode = phoneCodes.find((item) => item.id === value);
        
        if (selectedCode) {
            setPhoneNumberLength(selectedCode.phLength);
            setCountryCode(selectedCode.dial_code);
        }
        if (phoneNumber) {
            setPhoneNumber(null);
        }
        // form.resetFields('phone');
    };

    const handleNumberChange = (e) => {
        const { value } = e.target;
        setPhoneNumber(value);
    };

    const selectBeforeData = phoneCodes.map((item) => (
        <Option key={item.id} value={item.id}>
            {item.dial_code}
        </Option>
    ));

    const selectBefore = (
        <Select
            showSearch
            style={{ width: '80px' }}
            defaultValue="+91"
            width={200}
            onChange={changeCountryCode}
            className="select-before"
            optionFilterProp="children"
            filterOption={(input, option) => {
                return option.props.children.toLowerCase().includes(input.toLowerCase());
            }}
        >
            {selectBeforeData}
        </Select>
    );

    // const formItemLayout = {
    //     labelCol: { xs: { span: 24 }, sm: { span: 8 } },
    //     wrapperCol: { xs: { span: 24, offset: 4 }, sm: { span: 16 } },
    // };

    // const tailFormItemLayout2 = {
    //     wrapperCol: { xs: { span: 24, offset: 2 }, sm: { span: 24, offset: 4 } },
    // };

    // const tailFormItemLayout = {
    //     wrapperCol: { xs: { span: 24, offset: 0 }, sm: { span: 16, offset: 8 } },
    // };

    return (
        <Content>
            <div style={{ marginTop: 10, marginBottom: 15 }}>                
                <Row type="flex" justify="center">
                    <Col
                        xs={{ span: 21, offset: 0 }}
                        sm={{ span: 16, offset: 0 }}
                        md={{ span: 12, offset: 0 }}
                        lg={{ span: 10, offset: 0 }}
                        xl={{ span: 8, offset: 0 }}
                        xxl={{ span: 6, offset: 0 }}
                        // span={18}
                    >
                        <Card style={{minWidth:'50%', marginTop:'5%'}} > 
                            <Form form={form} onFinish={handleSubmit}>
                                <Row style={{marginTop:'4%', display:'flex', justifyContent:'center'}}>
                                    <Col span={24} style={{minWidth:'250px'}}>
                                        <div style={{ marginBottom: '20px' }}>
                                            <BodyTextHeading text={langdata.createAccount ? langdata.createAccount : 'Create your account'} />
                                        </div>
                                        <Form.Item hasFeedback name="email" rules={[
                                            { type: 'email', message: langdata.TheinputisnotvalidEmail ? langdata.TheinputisnotvalidEmail : 'The input is not valid E-mail!' },
                                            { required: true, message: langdata.PleaseinputyourEmail ? langdata.PleaseinputyourEmail : 'Please input your E-mail!' }
                                        ]}>
                                            <Input placeholder={langdata.Email ? langdata.Email : 'E-mail'} size="large" />
                                        </Form.Item>
                                    </Col>
                                    <Col span={24} style={{minWidth:'250px'}}>

                                        <Form.Item hasFeedback name="password" rules={[
                                            { required: true, message: langdata.Pleaseinputyourpassword ? langdata.Pleaseinputyourpassword : 'Please input your password!' },
                                            { validator: validateToNextPassword }
                                        ]}>
                                            <Input.Password type="password" placeholder={langdata.Password ? langdata.Password : 'Password'} size="large" 
                                                visibilityToggle={{
                                                    visible: passwordVisible,
                                                    onVisibleChange: setPasswordVisible,
                                                }}
                                            />
                                        </Form.Item>
                                    </Col>
                                    <Col span={24} style={{minWidth:'250px'}}>

                                        <Form.Item hasFeedback name="confirm" rules={[
                                            { required: true, message: langdata.Pleaseconfirmyourpassword ? langdata.Pleaseconfirmyourpassword : 'Please confirm your password!' },
                                            { validator: compareToFirstPassword }
                                        ]}>
                                            <Input.Password
                                                type="password"
                                                onBlur={handleConfirmBlur}
                                                placeholder={langdata.ConfirmPassword ? langdata.ConfirmPassword : 'Confirm Password'}
                                                size="large"
                                                visibilityToggle={{
                                                    visible: passwordVisible,
                                                    onVisibleChange: setPasswordVisible,
                                                }}
                                            />
                                        </Form.Item>
                                    </Col>
                                    <Col span={24} style={{minWidth:'250px'}}>

                                        <Form.Item hasFeedback name="phone" rules={[
                                            { required: false, message: langdata.Pleaseinputyourphonenumber ? langdata.Pleaseinputyourphonenumber : 'Please input your phone number!' },
                                            { validator: validatePhone }
                                        ]}>
                                            <Input
                                                addonBefore={selectBefore}
                                                style={{ width: '100%' }}
                                                placeholder={langdata.PhoneNumber ? langdata.PhoneNumber : 'Phone Number'}
                                                size="large"
                                                onChange={handleNumberChange}
                                                value={phoneNumber}
                                            />
                                        </Form.Item>
                                    </Col>

                                    {/* <Form.Item {...tailFormItemLayout2} style={{ marginBottom: 8 }}>
                                        <Checkbox name="agreement" valuePropName="checked" rules={[{ validator: checkCheckBox }]}>
                                            I have accepted the{' '}
                                            <a target="blank" href="https://quikdr.com/healthtips/privacy-policy-quikdr-health-tips/">
                                                terms and conditions
                                            </a>
                                        </Checkbox>
                                    </Form.Item> */}
                                    <Col span={24} style={{minWidth:'250px'}}>

                                        <Form.Item style={{ marginBottom: 8 }}
                                            name="agreement"
                                            valuePropName="checked"
                                            rules={[{ validator: checkCheckBox }]}
                                        >
                                            <Checkbox>
                                            I have accepted the{' '}
                                                <a
                                                    target="blank"
                                                    href="https://quikdr.com/healthtips/privacy-policy-quikdr-health-tips/"
                                                >
                                            terms and conditions
                                                </a>
                                            </Checkbox>
                                        </Form.Item>
                                    </Col>
                                    <Col span={24} style={{display:'flex', justifyContent:'center'}}>

                                        <Form.Item>
                                            <Row>
                                                <Col xs={10} sm={8} md={8} lg={8} xl={8}>
                                                    <Button 
                                                        style={{ width: '100%', paddingLeft: '40px',paddingRight: '40px' }} 
                                                        onClick={() => navigate('/login')}
                                                        size="large"
                                                    >
                                                        {`${langdata.Cancel ? langdata.Cancel : 'Cancel' }`}
                                                    </Button>
                                                </Col>
                                                <Col xs={4} sm={3} md={3} lg={3} xl={3}>
                                                    &nbsp;
                                                </Col>
                                                <Col xs={10} sm={12} md={12} lg={12} xl={12}>
                                                    <Button 
                                                        type="primary" 
                                                        htmlType="submit" 
                                                        size="large"
                                                        style={{ 
                                                            width: '100%',
                                                            whiteSpace: 'normal',
                                                            padding: '4px 8px',
                                                            lineHeight: '1.2'
                                                        }}
                                                    >
                                                        <ButtonText text = {langdata.Register ? langdata.Register : 'Register'} />
                                                    </Button>
                                                </Col>
                                            </Row>
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Form>
                        </Card>
                    </Col>
                </Row>
            </div>
            <CustomSpin spinning = {requesting} />
        </Content>
    );
};

// Register.propTypes = {
//   dispatch: PropTypes.func.isRequired,
//   requesting: PropTypes.object.isRequired,
//   countryList: PropTypes.array.isRequired,
// };

// const selectRequest = () => createSelector(makeSelectRequesting(), (value) => ({ value }));
// const selectCountry = () => createSelector(selectCountryList(), (value) => ({ value }));

// const mapStateToProps = (state) => ({
//   requesting: selectRequest()(state),
//   countryList: selectCountry()(state),
// });

export default Register;